import React, { useCallback } from 'react';
import { Text, Heading, Box } from '@landr/maestro';
import { Trans, t } from '@lingui/macro';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'types/enums';
import Slice from 'components/Slice/Slice';
import LinkWithArrow from 'components/LinkWithArrow/LinkWithArrow';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import InstrumentCard from './components/InstrumentCard/InstrumentCard';
import * as Styled from './styled';
import { instrumentsToRender } from './instrumentsToRender';

const useInstrumentsCardsGroup = () => {
    const navigate = useNavigate();

    const handleRedirectClick = useCallback(
        (pathname: string) => () => {
            navigate({
                pathname,
            });
        },
        [navigate],
    );

    return { handleRedirectClick };
};

export const _InstrumentsCardsGroup = ({
    handleRedirectClick,
}: {
    handleRedirectClick: (pathname: string) => () => void;
}) => {
    const toLocalizedPath = useToLocalizedPath();

    return (
        <Slice>
            <Box display="flex" flexDirection="column" py="md">
                <Heading as="h2" size="xl" mb="xxs">
                    <Trans>Top searched instruments</Trans>
                </Heading>
                <Text size="md" contrast="low">
                    <Trans>Check out hot and trending instruments</Trans>
                </Text>
                <Styled.CardsGroup>
                    {instrumentsToRender.map(
                        ({ icon, description, pathname }) => (
                            <InstrumentCard
                                onClick={handleRedirectClick(
                                    toLocalizedPath(pathname),
                                )}
                                description={description}
                                icon={icon}
                                key={description}
                            />
                        ),
                    )}
                </Styled.CardsGroup>
                <Box display="flex" justifyContent="flex-start">
                    <LinkWithArrow
                        to={toLocalizedPath(`/${RoutePaths.Browse}`)}
                        ctaCopy={t`Search more instruments`}
                    />
                </Box>
            </Box>
        </Slice>
    );
};

const InstrumentsCardsGroup = () => {
    const { handleRedirectClick } = useInstrumentsCardsGroup();

    return <_InstrumentsCardsGroup handleRedirectClick={handleRedirectClick} />;
};

export default InstrumentsCardsGroup;
